import Head from "next/head";
import { safeJsonStringify } from "src/utils/safe-json-stringify";

interface IJsonLdScriptProps {
    schema: unknown;
}

export const JsonLdScript = ({ schema }: IJsonLdScriptProps) => (
    <Head>
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: safeJsonStringify(schema) }} />
    </Head>
);
